import React, {Component} from 'react';
import {formatTime, uuid} from "../../../../../utils";
import {Tooltip} from "antd";
import BaseComponent from "../../../../../base/BaseComponent";
import close from "../close.png";
import $ from "jquery";

class Picture extends BaseComponent {

    state = {
        checked: false
    };

    //选中的话就返回item
    checkedAndReturn(){
        if(this.state.checked){
            return this.props.data;
        }
    }

    cancelChecked(){
        this.setState({checked: false});
    }

    render() {
        let {data} = this.props;
        let pStyle = {marginBottom:0,cursor:"pointer",color:"#bcbdbf",};
        let blockWidth = 280;
        let imgWidth = 80;
        let margin = 10;
        let attr = this.sysConfigGetValueByKey("resource.dialog.picture.detail.view.attr", "smallPath");
        let newSecondSelectColor =this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3")
        return (
            <div style={{cursor:"pointer"}}>
                <div style={{margin,marginTop:0,borderRadius:5,width:blockWidth,float:"left",background:"#eff5fd",border:`1px solid ${this.state.checked?newSecondSelectColor:"#fff"}`}}
                     onClick={()=>{
                         let checked = !this.state.checked;
                         this.state.checked = checked;
                         this.setState({});
                         this.props.onClick && this.props.onClick(data, checked);
                     }}
                >
                    <table width={"100%"} height={100} cellPadding={margin} cellSpacing={0} border={0}><tbody><tr>
                        <td><img src={data[attr]||data.icon} style={{borderRadius:5,objectFit:"cover"}} height={imgWidth} width={imgWidth} /></td>
                        <td>
                            <p style={{fontSize:14, ...pStyle, color:"#787474", width:blockWidth - imgWidth - margin * 2 - margin * 3}} className={"text-pointer"}>
                                <Tooltip placement={"topLeft"} title={data.name}><b>{data.name}</b></Tooltip></p>
                            <p style={pStyle}>来源：{data.source}</p>
                            <p style={pStyle}>日期：{formatTime(data.createTime)}</p>
                            <p style={pStyle}>尺寸：{data.width}*{data.height}<span onClick={(e)=>{
                                this.detailDialog.show();
                                e.stopPropagation();
                            }} style={{float:"right",cursor:"pointer",color:this.themeBgColor}}>预览</span></p>
                        </td>
                    </tr></tbody></table>
                </div>
                <DetailDialog ref={detailDialog=>this.detailDialog=detailDialog} path={data[attr]||data.icon} />
            </div>
        );
    }
}

export class DetailDialog extends BaseComponent{

    id = "b"+uuid();

    show = ()=>{
        $(`#${this.id}`).show();
    };

    hide = ()=>{
        $(`#${this.id}`).hide();
    };

    //esc事件
    // handleKeyDown = (e) => {
    //     if (e.keyCode === 27) {
    //         this.hide();
    //         e.stopPropagation();
    //     }
    // }
    //
    // componentDidMount() {
    //     document.addEventListener('keydown',this.handleKeyDown);
    // }
    //
    // componentWillUnmount() {
    //     document.removeEventListener('keydown',this.handleKeyDown);
    // }

    render() {
        let imgMaxWidth = document.body.clientWidth * 0.8;
        let imgMaxHeight = document.body.clientHeight * 0.8;
        return <div id={this.id} style={{display: "none"}}
                    // onKeyDown={(e)=>this.handleKeyDown(e)}
        >
            <div style={{position:"fixed", top:0, left:0, zIndex:9998, opacity:0.4, background:"#000",width:document.body.clientWidth,height:document.body.clientHeight}} />
            <table style={{position: "fixed", top: 0, left: 0, zIndex: 9999}} width={document.body.clientWidth}
                   height={document.body.clientHeight} cellSpacing={0} cellPadding={0} border={0}>
                <tbody>
                <tr>
                    <td valign={"middle"} align={"center"}>
                        <img src={this.props.path} style={{maxWidth: imgMaxWidth, maxHeight: imgMaxHeight}}/>
                        <img onClick={(e) => {
                            this.hide();
                            e.stopPropagation();
                        }} src={close} style={{
                            position: "fixed",
                            top: 100,
                            right: 100,
                            width: 88,
                            height: 88,
                            cursor: "pointer"
                        }}/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    }
}

export default Picture;